"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSymbolWrapperStyles = exports.useLogoStyles = void 0;
var _createStyles = require("../../styles/createStyles");
const useLogoStyles = exports.useLogoStyles = (0, _createStyles.createStyles)(() => ({
  root: {
    color: '#0274CA'
  },
  inverted: {
    color: '#FFF'
  }
}));
const useSymbolWrapperStyles = exports.useSymbolWrapperStyles = (0, _createStyles.createStyles)(_ref => {
  let {
    theme
  } = _ref;
  return {
    wrapper: {
      textAlign: 'center',
      overflow: 'hidden',
      background: 'radial-gradient(83.33% 83.33% at 50% 0%, #30B0FF 0%, #0274CA 100%)',
      borderRadius: theme.busbud.styles.rounding.circle,
      flexShrink: 0
    },
    wrapperMd: {
      width: theme.busbud.spacing(6),
      height: theme.busbud.spacing(6),
      paddingTop: '9px'
    },
    wrapperSm: {
      width: theme.busbud.spacing(5),
      height: theme.busbud.spacing(5),
      paddingTop: '7px'
    },
    wrapperXs: {
      width: theme.busbud.spacing(3.5),
      height: theme.busbud.spacing(3.5),
      paddingTop: '4px'
    }
  };
});